import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import leftLogo from "../../assets/abbottLogo.png";
import abbottLogo from "../../assets/logo.png";
import rightLogo from "../../assets/orevan.png";
import orevanEventsLogo from "../../assets/orevanEventsLogo.png";
import "./Login.css";
import eventLogo from "../../assets/loginPage.png";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const authContext = useAuth();
  const [showSpinning, setShowSpinning] = useState(false);

  useEffect(() => {
    // If user is already authenticated, redirect to home
    if (authContext.currentUser) {
      navigate('/');
    }
  }, [authContext.currentUser, navigate]);

  // If auth context is not available yet, show loading
  if (!authContext) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-[18vw] h-[18vw] bg-gradient-to-tr from-blueColor to-blue-500 rounded-full animate-spin"></div>
      </div>
    );
  }

  const { loginWithMicrosoft } = authContext;

  const handleMicrosoftLogin = async () => {
    try {
      setShowSpinning(true);
      const result = await loginWithMicrosoft();

      if (result.error) {
        toast.error(result.error);
        return;
      }

      if (result.success) {
        toast.success('Successfully authenticated!');
      }
    } catch (err) {
      toast.error(`Microsoft login failed: ${err.message}`);
    } finally {
      setShowSpinning(false);
    }
  };

  return (
    <div className="flex w-full h-screen">
      <ToastContainer />
      <div className="w-full flex items-center justify-center lg:w-1/2">
        <div className="bg-white px-10 py-20 rounded-3xl border-2 border-gray-100 shadow xl:w-3/5 lg:w-3/4 md:w-3/5">
          <div className="flex justify-center">
            <img
              src={orevanEventsLogo}
              alt=""
              className="w-60"
              style={{ objectFit: "contain" }}
            />
          </div>
          <p className="font-medium text-lg text-gray-500 mt-4 text-center">
            Welcome Back! Please sign in with your Abbott account
          </p>
          <div className="mt-8">
            <button
              type="button"
              onClick={handleMicrosoftLogin}
              className="w-full bg-white hover:bg-gray-50 text-black border border-gray-200 font-semibold py-2.5 px-4 rounded flex items-center justify-center gap-2"
            >
              <img src={abbottLogo} alt="Abbott Logo" className="w-5 h-5" />
              <span>Sign in with Abbott</span>
              {showSpinning && (
                <svg
                  className="animate-spin h-5 w-5 text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className="hidden relative lg:flex h-full w-1/2 items-center justify-center flex-col bg-gray-100">
        <div className="mt-[-3vw] mr-[15vw]">
          <div className="w-[18vw] h-[18vw] bg-gradient-to-tr from-blueColor to-blue-500 rounded-full animate-spin"></div>
        </div>
        <div className="mt-[-12vw] z-10">
          <img className="w-[20vw]" src={eventLogo} alt="" />
        </div>
        <div className="mt-[-10vw] ml-[8vw]">
          <div className="w-[18vw] h-[18vw] bg-gradient-to-tr from-purpleColor to-lightPurple rounded-full animate-spin"></div>
        </div>

        <div className="w-full absolute bottom-0 bg-white/10 backdrop-blur-lg flex justify-end flex-col">
          <div className="grid lg:grid-cols-4 xl:grid-cols-6 gap-x-32 lg:px-4 xl:px-10 mb-4 items-center">
            <div className="lg:col-span-2 xl:col-span-3 mt-3">
              <img className="w-56" src={leftLogo} alt="" />
            </div>
            <div className="lg:col-span-2 xl:col-span-3 flex justify-end">
              <img
                src={rightLogo}
                className="w-44"
                alt=""
                style={{ objectFit: "contain" }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;

